import { Reveal } from "./Reveal";
import { Coffee } from "lucide-react";
import { mediaUrl } from "@/lib/api";

const MENU = [
  { name: "Espresso du torréfacteur", price: "2,00€" },
  { name: "Latte noisette caramélisée", price: "4,50€" },
  { name: "Cappuccino de spécialité", price: "4,00€" },
  { name: "Thés & infusions bio", price: "3,50€" },
  { name: "Limonade artisanale du Gers", price: "4,00€" },
  { name: "Chocolat chaud grand cru", price: "4,50€" },
  { name: "Cookie maison", price: "3,00€" },
  { name: "Gâteau du jour", price: "4,50€" },
];

export default function CafeMenu({ content }) {
  const items = content?.menu_items?.length ? content.menu_items : MENU;
  return (
    <section id="cafe" data-testid="cafe-section" className="py-20 md:py-28 bg-[#FBF8F3] rounded-b-[3rem]">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8 grid lg:grid-cols-12 gap-10 items-center">
        <Reveal className="lg:col-span-5">
          <div className="relative">
            <div className="overflow-hidden rounded-2xl border-[6px] border-white shadow-[0_30px_60px_-25px_rgba(32,24,21,0.3)] rotate-[-2deg]">
              {content?.cafe_image ? (
                <img
                  src={mediaUrl(content.cafe_image)}
                  alt="Café de spécialité servi dans des tasses artisanales"
                  data-testid="cafe-image"
                  className="w-full h-80 object-cover"
                />
              ) : (
                <div data-testid="cafe-image" className="w-full h-80 bg-[#EFE6DC]" />
              )}
            </div>
            <div className="absolute -bottom-6 -right-4 rounded-2xl bg-[#6B7C5A] text-[#FBF8F3] px-5 py-4 rotate-2 shadow-lg">
              <p className="font-display italic text-lg leading-tight">Torréfacteur<br />local du Gers</p>
            </div>
          </div>
        </Reveal>

        <div className="lg:col-span-7">
          <Reveal>
            <p className="text-xs font-medium uppercase tracking-[0.25em] text-[#C85A32] mb-4">Le café</p>
            <h2 className="font-display tracking-tight text-[#201815] text-3xl sm:text-4xl lg:text-5xl leading-tight mb-4">
              De quoi savourer <span className="italic text-[#C85A32]">l'instant.</span>
            </h2>
            <p className="text-[#5C4E48] text-base leading-relaxed max-w-xl mb-10">
              {content?.cafe_text || "Pendant que votre pièce prend vie, notre comptoir vous sert le meilleur du Gers : cafés de spécialité, boissons artisanales et pâtisseries maison. Une boisson chaude est offerte pour tout atelier réservé à l'ouverture."}
            </p>
          </Reveal>

          <div className="grid sm:grid-cols-2 gap-x-10 gap-y-1" data-testid="cafe-menu-list">
            {items.map((item, i) => (
              <Reveal key={item.name} delay={i * 0.04} y={16}>
                <div className="flex items-baseline justify-between gap-3 border-b border-dashed border-[#E5DCD3] py-3.5 group">
                  <span className="flex items-center gap-2.5 text-sm text-[#201815] group-hover:text-[#C85A32] transition-colors duration-300">
                    <Coffee size={13} className="text-[#C85A32]/50 shrink-0" />
                    {item.name}
                  </span>
                  <span className="font-mono-brand text-sm text-[#8A7971]">{item.price}</span>
                </div>
              </Reveal>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
